import React, { useEffect, useState } from 'react';
import { FaArrowRightLong } from "react-icons/fa6";
import { MdClose } from "react-icons/md";
import { useParams } from 'react-router-dom';
import { fetchLumpBarcode } from '../../Store/PHPSlice/Cutting/clothIssue';
import { selectLumpBarcode } from '../Selectors/Master/ItemSelectors';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCStkLamplist, insertClothStkLump } from '../../Store/PHPSlice/clothStock';
import { selectCstklump } from '../Selectors/UploadStock/ReadyMSelector';
import CircularProgress from '@mui/material/CircularProgress';


const LumpMtrTbl2 = () => {
    const { idx, clothId, mtr, locnm } = useParams();
    const [lumpRows, setLumpRows] = useState([]);
    const [lumpTotMtr, setLumpTotMtr] = useState(0);
    const [barcodeLump, setBarcodeLump] = useState(null);

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const lumpbar = useSelector(selectLumpBarcode);
    const lumpdata = useSelector(selectCstklump);
    const [locNm, setLocNm] = useState('');
    // console.log(lumpdata);

    useEffect(() => {

        setLocNm(locnm);
        const postPara = {
            idx: idx,
            clothId: clothId
        };
        // console.log(cid);
        dispatch(fetchCStkLamplist(postPara));
    }, [idx, clothId]);

    useEffect(() => {
        dispatch(fetchLumpBarcode());
    }, []);


    useEffect(() => {
        if (lumpbar?.data?.Lumpbar) {
            const data = {
                old: lumpbar?.data?.Lumpbar,
                new: lumpbar?.data?.Lumpbar
            };
            // setBarcodeLump(data);

            if (lumpdata?.data?.length > 0) {
                // const data = lumpdata.data;
                const data = JSON.parse(JSON.stringify(lumpdata.data));
                setLumpRows(data);

                const totmtr = data?.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
                setLumpTotMtr(totmtr.toFixed(2));
            } else {
                const no_bar = data?.new?.split('-');
                var bar = `${no_bar[0]}-${parseFloat(no_bar[1])}`;
                const updateBarcode = `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}`;

                const lumpdata = {
                    barcode: bar,
                    color: '',
                    mtr: mtr,
                    locNm: locnm,
                    selected: false
                };
                // console.log(lumpdata);
                // setLumpRows((prevRows) => [...prevRows, lumpdata]);
                setLumpRows([lumpdata]);
                setBarcodeLump(prev => ({
                    ...prev,
                    new: updateBarcode,
                    old: lumpbar?.data?.Lumpbar
                }));
                setLumpTotMtr(mtr);

                // const postData = PostObj(Id, lumpRows, userId);
                // localStorage.setItem("lumpRows", JSON.stringify(postData));
            }

        }
    }, [lumpbar]);


    const handleLumpSelection = (index) => {
        const newRows = [...lumpRows];
        newRows[index].selected = !newRows[index].selected;
        setLumpRows(newRows);
    };

    const handleLumpColor = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].color = value.toUpperCase();
        setLumpRows(updateLumps);
    };

    const handleLumpMtr = (index, value) => {
        const updateLumps = [...lumpRows];
        updateLumps[index].mtr = value;
        // Calculate the sum of all mtr values in the lumpRows array
        const totalMtr = updateLumps.reduce((sum, lump) => {
            // Ensure that mtr values are numeric and handle potential empty values
            const mtrValue = parseFloat(lump.mtr) || 0;
            return sum + mtrValue;
        }, 0);
        setLumpTotMtr(totalMtr.toFixed(2));
        setLumpRows(updateLumps);
    };

    const handleAddlump = () => {
        const no_bar = barcodeLump?.new.split('-');
        var bar = no_bar?.length > 0 ? `${no_bar[0]}-${parseFloat(no_bar[1])}` : '';
        const updateBarcode = no_bar?.length > 0 ? `${no_bar[0]}-${parseFloat(no_bar[1]) + 1}` : '';
        const lumpdata = {
            barcode: bar,
            color: '',
            mtr: '',
            locNm: locNm,
            selected: false
        };
        setLumpRows((prevRows) => [...prevRows, lumpdata]);
        setBarcodeLump(prev => ({
            ...prev,
            new: updateBarcode
        }));
    };

    const handleRemoveLumps = () => {
        const filteredRows = lumpRows.filter((row) => !row.selected);
        setLumpRows(filteredRows);
        // const no_bar = barcodeLump?.new.split('-');
        // const updateBarcode = `${no_bar[0]}-${parseFloat(no_bar[1]) - 1}`;
        // setBarcodeLump(prev => ({
        //     ...prev,
        //     new: updateBarcode
        // }));
        const totmtr = filteredRows.reduce((acc, mtr) => acc + parseFloat(mtr.mtr), 0);
        setLumpTotMtr(totmtr.toFixed(2));
    };

    const userId = JSON.parse(sessionStorage.getItem('user'))?.ID;
    function PostObj(idx, clothId, lumpRows, userId) {

        const data = {
            baleidx: idx,
            clothid: clothId,
            lumpRows: lumpRows,
            userId: userId
        };

        return data;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();



        const resend = {
            index: parseFloat(idx) - 1,
            totmtr: lumpTotMtr
        };

        if (window.opener && window.opener.handleResendFromChild2) {
            window.opener.handleResendFromChild2(resend);
        }

        setLoading(true);

        try {
            const postData = PostObj(idx, clothId, lumpRows, userId);
            // console.log(postData);
            // localStorage.setItem("lumpRows", JSON.stringify(postData));
            const result = await dispatch(insertClothStkLump(postData)).unwrap();
            console.log('POST request successful!', result);
            alert("Record Add");
            window.close();

        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };
    return (
        <>
            <div className="lump-content">
                <h3>Lump Details </h3>
                <div className="button-group">
                    <button className="add" onClick={handleAddlump}>Add</button>
                    <button className="delete" onClick={handleRemoveLumps}>Remove</button>
                </div>
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Location</th>
                            <th>Barcode</th>
                            <th>Color</th>
                            <th>Lump Mtr</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lumpRows?.map((lumpRow, lumpIndex) => (
                            <>
                                <tr key={lumpIndex}>
                                    <td> <input
                                        type="checkbox"
                                        checked={lumpRow.selected}
                                        onChange={() => handleLumpSelection(lumpIndex)}
                                    />{" "}
                                        {lumpIndex + 1}
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="locNm"
                                            value={lumpRow.locNm}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="barcode"
                                            value={lumpRow.barcode}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="color"
                                            value={lumpRow.color}
                                            onChange={(e) => handleLumpColor(
                                                lumpIndex,
                                                e.target.value
                                            )}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Lump Mtr"
                                            value={lumpRow.mtr}
                                            onChange={(e) => handleLumpMtr(
                                                lumpIndex,
                                                e.target.value
                                            )}
                                        />
                                    </td>

                                </tr>
                            </>
                        ))}
                        <tr>
                            <td> </td>
                            <td> </td>
                            <td> </td>
                            <td>
                                <span className="tot-lump">Total Lump Mtr</span>
                            </td>
                            <td>
                                <span className="tot-lump">{lumpTotMtr}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button className="add" onClick={handleSubmit} disabled={loading === true}>
                    {
                        loading === true ?
                            <><CircularProgress size="20px" style={{ color: 'white' }} /> wait...</> :
                            "Submit"
                    }
                </button>
            </div>
        </>
    );
}

export default LumpMtrTbl2;
